import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 0 20px 15px 25px;
`;

export const Content = styled.p`
  text-align: center;
  margin: 30px 0 30px 0;
  font-family: lato;
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
`;
